module.exports = __webpack_public_path__ + "img/info-2.0a9ee58b.svg";